import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useContext, useState, useEffect } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Loader from '../atoms/Loader/Loader';
import OfferAndDeal from '../102_ListingOffersAndDeals/components/OfferAndDeal';
import { LOCAL_STORAGE_APP_CURRENCY } from '../102_ListingOffersAndDeals/ListingOffersAndDeals';
import CurrencySelector from '../102_ListingOffersAndDeals/components/CurrencySelector';
import { getColorByTheme, getPageThemeColors, get, canUseDOM, hexToRgb, getDictionaryItem } from '../../utils';
import getListing from '../../utils/getListing';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { convertToAnalyticObject } from '../../utils/analytics';
import { getHostName } from '../atoms/InteractiveMap/utils/getHostName';
var OfferAndDealDetails = function OfferAndDealDetails(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var language = get(sitecoreContext, 'language') || 'en';
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currencyIndex = _useState4[0],
    setCurrencyIndex = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    currencyName = _useState6[0],
    setCurrencyName = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    deal = _useState8[0],
    setDeal = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    loading = _useState10[0],
    setLoading = _useState10[1];
  var host = canUseDOM ? window.location.hostname : '';
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var dictionary = get(fields, 'data.dictionary');
  var socialSharing = get(fields, 'data.socialSharing');
  var currencies = get(fields, 'data.settings.currencies.currencies', []);
  var indexName = get(fields, 'data.settings.searchIndex.jss.value', '');
  var OaDID = get(fields, 'data.item.id', '');
  var countryItems = get(fields, 'data.countries.countryValues') || [];
  var fromText = getDictionaryItem(dictionary, 'from') || '#';
  var offText = getDictionaryItem(dictionary, 'off') || '#';
  var expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '#';
  var moreInfoText = getDictionaryItem(dictionary, 'moreInfo') || '#';
  var bookNowText = getDictionaryItem(dictionary, 'bookNow') || '#';
  var termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '#';
  var pageTitle = getDictionaryItem(dictionary, 'dealsInDubai') || '#';
  var ratingTextStar = getDictionaryItem(dictionary, 'star') || '';
  var ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';

  /* Params elements */
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  /* End Params elements */

  var variables = BackgroundColorHex ? {
    "--offer-and-deal-details-background-color": BackgroundColorHex,
    "--offer-and-deal-details-background-color-rgb": hexToRgb(BackgroundColorHex, true),
    "--offer-and-deal-details-background-active-color": ActiveColorHex,
    "--offer-and-deal-details-color": ColorHex
  } : {
    "--offer-and-deal-details-background-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--offer-and-deal-details-background-color-rgb": hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
    "--offer-and-deal-details-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--offer-and-deal-details-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  useEffect(function () {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  useEffect(function () {
    var lsCurrency = localStorage.getItem(LOCAL_STORAGE_APP_CURRENCY);
    setCurrencyName(lsCurrency || 'AED');
  }, []);
  useEffect(function () {
    if (OaDID && indexName) {
      setLoading(true);
      var itemFilters = {
        filters: "(objectID:".concat(OaDID.toLowerCase(), ")")
      };
      var indexLanguaged = "".concat(getHostName(host)).concat(indexName, "_").concat(language);
      getListing(indexLanguaged, itemFilters).then(function (response) {
        setLoading(false);
        setDeal(response && response.hits && response.hits[0]);
      });
    }
  }, []);
  if (!deal || !deal.objectID) {
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-8 col-sm-9 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__title"
  }, pageTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: {
      value: pageTitle
    },
    className: "h2 c-title__text"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-4 col-sm-3 col-xl-2 pb-3"
  }, !!currencies.length && /*#__PURE__*/React.createElement(CurrencySelector, {
    changeCurrency: setCurrencyIndex,
    changeCurrencyName: setCurrencyName,
    currencyName: currencyName,
    currencies: currencies,
    rtl: rtl,
    themeVariables: variables
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, loading && /*#__PURE__*/React.createElement(Loader, {
    color: BackgroundColorHex || primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary
  }), deal && deal.objectID && /*#__PURE__*/React.createElement("div", {
    className: "row deals-grid--list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, /*#__PURE__*/React.createElement(OfferAndDeal, {
    fromText: fromText,
    offText: offText,
    expiresSoonText: expiresSoonText,
    moreInfoText: moreInfoText,
    bookNowText: bookNowText,
    termsAndConditionsText: termsAndConditionsText,
    deal: deal,
    rtl: rtl,
    currency: currencyName,
    currencyIndex: currencyIndex,
    gridMode: false,
    socialSharing: socialSharing,
    useTruncate: false,
    themeVariables: variables,
    eventsAnalytics: eventsAnalytics,
    params: params,
    ratingTextStars: ratingTextStars,
    ratingTextStar: ratingTextStar,
    countryItems: countryItems
  })))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var rtl = _ref2.rtl,
    children = _ref2.children,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
export default OfferAndDealDetails;